import React from "react";
import SendIcon from "@mui/icons-material/Send";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";

type ChatMessageInputFormProps = {
  sendMessage: (message: string) => Promise<void>;
};

export const ChatMessageInputForm: React.FC<ChatMessageInputFormProps> = ({ sendMessage }) => {
  const inputRef = React.createRef<HTMLInputElement>();

  const sendBtnClicked = () => {
    if (!inputRef.current) return;
    const text = inputRef.current?.value.trim();
    if (text.length === 0) return;
    sendMessage(text);
    inputRef.current.value = "";
  };

  //If user press ctrl-enter or command-enter will send message
  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Enter" && (e.ctrlKey || e.metaKey)) {
      sendBtnClicked();
    }
  };

  return (
    <>
      <form
        noValidate
        autoComplete="off"
        style={{
          width: "100%",
          margin: "0 auto",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <TextField
          id="standard-text"
          label="Please type message"
          inputRef={inputRef}
          multiline
          maxRows={10}
          onKeyDown={handleKeyDown}
          sx={{ width: "100%" }}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={sendBtnClicked}
          sx={{ borderRadius: "0" }}
        >
          <SendIcon />
        </Button>
      </form>
    </>
  );
};
